const TrackedListKey = 'EgY1CouXlq4B1myODmlL';

const getTrackedList = () => {
  try {
    let trackedList = atob(localStorage.getItem(TrackedListKey));
    return (JSON.parse(trackedList));
  } catch (error) {
    // console.log('error => ', error);
    return [];
  }
};

const setTrackedList = (payload: any) => {
  try {
    let trackedList = btoa(JSON.stringify(payload));
    localStorage.setItem(TrackedListKey, trackedList);
  } catch (error) {
    // console.log('error => ', error);
  }
};

const resetTrackedList = () => {
  try {
    localStorage.removeItem(TrackedListKey);
  } catch (error) {
    // console.log('error => ', error);
  }
};

// In case user login via B2C/Microsoft
// After login successful if user does not have permission to access QSHIP
// Redirect user to logout B2C/Microsoft page to clear the token
// This localStorage key is to prompt the error message for above case
const UserNotHavePermission = "userNotHavePermission";
const getUserNotHavePermission = () => localStorage.getItem(UserNotHavePermission);
const setUserNotHavePermission = (errorMessage: string) => localStorage.setItem(UserNotHavePermission, errorMessage);
const deleteUserNotHavePermission = () => localStorage.removeItem(UserNotHavePermission);

export {
  getTrackedList,
  setTrackedList,
  resetTrackedList,
  getUserNotHavePermission,
  setUserNotHavePermission,
  deleteUserNotHavePermission,
};
